import type { OverlayDimensions } from "./maps/types";

/**
 * Generator-specific: real footprint of a generator enclosure, used to size the
 * to-scale map overlay (#44). SKU strings key off what the `recommend` API returns.
 * Entries here are illustrative and MUST be reconciled against manufacturer spec
 * sheets and the actual SKUs in pricing.json before production. The default keeps the
 * POC genuinely to-scale for any air-cooled unit.
 *
 * NOTE: this lives OUTSIDE lib/maps/ on purpose — lib/maps/ stays generator-agnostic
 * so solar can reuse it without dragging generator concepts along.
 */
export const DEFAULT_DIMENSIONS: OverlayDimensions = { widthMeters: 1.22, depthMeters: 0.66 };

const BY_SKU: Record<string, OverlayDimensions> = {
  "generac-guardian-26kw": { widthMeters: 1.22, depthMeters: 0.64 },
};

export function footprintForSku(sku: string | null | undefined): OverlayDimensions {
  if (sku && BY_SKU[sku]) return BY_SKU[sku];
  return DEFAULT_DIMENSIONS;
}
